import { Table, TableContainer, TableHead, TableRow, TableCell, TableBody, Box } from '@mui/material';
import { useEffect } from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { useQuoteState } from 'shared/contexts';
import { OrderNote } from 'shared/types';
import { SxProps, Theme } from '@mui/material';
import { OrderNotesSummary } from './order-notes-summary';

const rootStyles: SxProps<Theme> = {
  width: '100%',
};
const orderNotesStyles: SxProps<Theme> = (theme: Theme) => ({
  marginTop: '20px',
  width: '100%',
  '& .MuiTableRow-head': {
    backgroundColor: theme.palette.background.paper,
  },
  '& .MuiTableCell-head': {
    fontWeight: 'normal',
    '&:nth-of-type(1)': {
      paddingLeft: theme.spacing(5),
    },
  },
});

export function OrderNotesDetails() {
  const { newOrderNote } = useQuoteState();
  const { watch } = useFormContext();
  const { fields, remove, append } = useFieldArray({
    name: 'orderNotes',
  });

  const watchOrderNotes = watch('orderNotes') as OrderNote[];
  const controlledFields = fields.map((field, index) => ({
    ...field,
    ...watchOrderNotes?.[index],
  }));

  useEffect(() => {
    if (newOrderNote) {
      append(newOrderNote);
    }
  }, [newOrderNote, append]);

  return (
    <Box sx={rootStyles}>
      <Box sx={orderNotesStyles}>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell align='left'>Description</TableCell>
                <TableCell align='left'>Created By</TableCell>
                <TableCell align='left'>Creation Date</TableCell>
                <TableCell align='right' />
              </TableRow>
            </TableHead>
            <TableBody>
              {controlledFields.map((orderNote, index) => (
                <OrderNotesSummary key={orderNote.id} orderNote={orderNote} index={index} remove={remove} />
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Box>
  );
}
